// extracted by mini-css-extract-plugin
export default {"icon":"styles_icon__I9P2C","copyText":"styles_copyText__Fjppe"};